import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromStaticDataReducer from '../reducers';
import * as staticDataCountriesReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

//#region Static Data ROOT STATE
export const getAuthState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);
//#endregion

export const getStaticDataProductProvidersState = createSelector(
  getAuthState,
  state => state[fromStaticDataReducer.fromStaticDataProductProvidersReducer.productProvidersFeatureKey]
);

export const getStaticDataProductProvidersFailure = createSelector(
  getStaticDataProductProvidersState,
  staticDataCountriesReducer.fromStaticDataProductProvidersReducer.getProductProvidersFailure
);

export const getStaticDataProductProvidersResponse = createSelector(
  getStaticDataProductProvidersState,
  staticDataCountriesReducer.fromStaticDataProductProvidersReducer.getProductProvidersResponse
);

export const getStaticDataProductProvidersisLoaded = createSelector(
  getStaticDataProductProvidersState,
  staticDataCountriesReducer.fromStaticDataProductProvidersReducer.getProductProvidersIsLoaded
);
